<template>
  <div :class="[prefixCls]">
    <div class="menu-trigger" @click="toggleCollapsed()">
      <MIcon prefix="menu" icon="caidan" size="28" />
    </div>
    <div class="flex items-center" @click="router.push(getUserStore().getUserInfo.homePath)">
      <img v-if="project.projectLogo" :src="project.projectLogo" />
      <Divider v-if="project.projectLogo" type="vertical" class="!mx-16px !h-22px" />
      <img :src="project.platformLogo" />
      <div v-show="showTitle" class="ml-8px truncate md:opacity-100" :class="getTitleClass">
        {{ project.platformTitle }}
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { Divider } from 'ant-design-vue';
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { useMenuSetting } from '@mts/hooks/setting/useMenuSetting';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import { getUserStore } from '@/store';

  const props = defineProps({
    /**
     * Whether to show title
     */
    showTitle: { type: Boolean, default: true },
    /**
     * The title is also displayed when the menu is collapsed
     */
    alwaysShowTitle: { type: Boolean },
  });

  const router = useRouter();
  const { prefixCls } = useDesign('app-logo');
  const project = computed(() => getUserStore().getProjectInfo);
  const { toggleCollapsed } = useMenuSetting();

  const getTitleClass = computed(() => [
    `${prefixCls}__title`,
    {
      'xs:opacity-0': !props.alwaysShowTitle,
    },
  ]);
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-app-logo';

  .@{prefix-cls} {
    display: flex;
    align-items: center;
    max-width: 80vw;
    cursor: pointer;

    &__title {
      color: @text-color-base;
      font-size: 18px;
      font-weight: 500;
      line-height: normal;
    }

    .menu-trigger {
      display: flex;
      align-items: center;
      height: 100%;
      margin-right: 8px;
      padding: 0 10px;
      background-color: @primary-color;
      color: @white;
    }

    img {
      max-width: fit-content;
      height: @logo-height;
      object-fit: contain;
    }
  }

  .mts-pad .@{prefix-cls} {
    .menu-trigger {
      font-size: 26px;
    }
  }
</style>
